import { ReferralEventData } from '../../types/';

import { TableHeaderRow } from 'routes/singleEvent/components/EventArenaSection/TableHeaderRow';

import { Pagination } from 'components/pagination/Pagination';
import Spacing from 'components/spacing/Spacing';

import { usePagination } from '../../hooks/usePagination';

import { fillEmptyRows } from '../../helpers/analytics-table.helper';
import { AnalyticsTableItem } from './AnalyticsTableItem';

type AnalyticsTableProps = {
  tableData: ReferralEventData['tableData'];
};

export const AnalyticsTable = ({ tableData }: AnalyticsTableProps) => {
  const { rows } = tableData;

  const {
    paginatedItems,
    currentPage,
    totalPages,
    hasNextPage,
    hasPreviousPage,
    shouldShowPagination,
    goToPage,
    goToNextPage,
    goToPreviousPage,
  } = usePagination(rows || [], { itemsPerPage: 5 });

  const filledPaginatedItems = fillEmptyRows(paginatedItems);

  return (
    <div>
      <div className="tw-mb-[26px] tw-flex tw-w-full tw-flex-row tw-items-end tw-gap-[16px] tw-text-white lg:tw-items-center">
        <TableHeaderRow title="#" variant="referral" width="tw-flex-[0.3]" />
        <TableHeaderRow title="Wallet Address" variant="referral" />
        <TableHeaderRow title="WNFT Purchased" variant="referral" />
        <TableHeaderRow title="Prize" variant="referral" />
      </div>

      <div className="tw-flex tw-flex-col">
        <div className="tw-flex tw-flex-col tw-gap-[8px] lg:tw-gap-[10px]">
          {filledPaginatedItems.map((row, index) => (
            <AnalyticsTableItem
              key={index}
              rank={row.rank}
              walletAddress={row.walletAddress}
              wnftPurchased={row.wnftPurchased}
              prize={row.prize}
              isActive={row.isActive}
            />
          ))}
        </div>

        <Spacing height={24} mobileHeight={24} />

        {shouldShowPagination && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            hasNextPage={hasNextPage}
            hasPreviousPage={hasPreviousPage}
            goToPage={goToPage}
            goToNextPage={goToNextPage}
            goToPreviousPage={goToPreviousPage}
            variant="analytics"
          />
        )}
      </div>
    </div>
  );
};
